<script lang="ts">
    import { session } from '$lib/stores';
  import Alert from './Alert.svelte';
</script>

<Alert severity="warning">
  {#if $session?.role && ['admin', 'moderator'].includes($session?.role)}
    Este contenido no está publicado, solo es visible a los administradores o personas que posean el enlace privado
  {:else}
    Este contenido no está publicado, solo es visible usando un enalce privado
  {/if}
</Alert>
